import { axiosInstance } from "@/axios/interceptors";

export type ResendVerificationEmailPayload = {
	guest_id: number;
	email_verification_callback: string;
};

export const resendVerificationEmail = async (
	payload: ResendVerificationEmailPayload,
) => {
	const response = await axiosInstance.post(
		"/guests/resend_email_verification",
		{
			...payload,
		},
	);
	return response.data;
};
